import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { GetTicketTypeById, GetTicketTypeInfosByTicketTypeId, deleteTicketsFromBasket, GetShopBasketOrder } from "../utils/api";
import { useLanguage } from "../hooks/useLanguage";
import { useOrder } from "../hooks/useOrder";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import OrderSummary from "./components/OrderSummary";

import iconDelete from "../images/icons/delete.svg";

const Information = () => {
    const [regularToken, setRegularToken] = useState(null);
    const [bookingType, setBookingType] = useState(null);
    const [resources, setResources] = useState({});

    const [tickets, setTickets] = useState([]);
    const [currentOrder, setCurrentOrder] = useState(null);

    const { language, languageId } = useLanguage();
    const username = localStorage.getItem("username");

    let navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const order = useOrder(baseUrl);

    useEffect(() => {
        setRegularToken(localStorage.getItem("token"));
        setBookingType(localStorage.getItem("bookingType"));
    }, []);

    useEffect(() => {
        if (language) {
            requestResources();
        }
    }, [language]);

    useEffect(() => {
        if (order && order?.id) {
            setCurrentOrder(order);
        }
    }, [order]);

    useEffect(() => {
        if (currentOrder && currentOrder?.tickets?.length > 0) {
            loadTickets(currentOrder?.tickets)
        }
    }, [currentOrder]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadTickets = async (bookedTickets) => {
        try {
            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await fetchTicketTypeById(ticket.ticketTypeId);

                    const ticketTypeInfoResp = await fetchtTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const info = ticketTypeInfoResp?.ticketTypeInfos;

                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            setTickets(updatedTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const fetchTicketTypeById = async (id) => {
        try {
            if (!regularToken) {
                throw new Error("No regularToken token found at fetchTicketTypeById");
            }
            const data = await GetTicketTypeById(baseUrl, "token", regularToken, id);

            return data;
        } catch (error) {
            console.error('Error fetching ticket type by id:', error);
        }
    };

    const fetchtTicketTypeInfosByTicketTypeId = async (ticketTypeId) => {
        try {
            if (!regularToken) {
                throw new Error("No regularToken token found at fetchtTicketTypeInfosByTicketTypeId");
            }
            const data = await GetTicketTypeInfosByTicketTypeId(baseUrl, "token", regularToken, ticketTypeId);

            return data;
        } catch (error) {
            console.error('Error fetching ticket type infos by ticket type id:', error);
        }
    };

    const reloadOrder = async () => {
        try {
            if (!regularToken || !currentOrder?.id) {
                return;
            }
            const updatedOrder = await GetShopBasketOrder(baseUrl, "token", regularToken, currentOrder.id);
            setCurrentOrder(updatedOrder);
        } catch (error) {
            console.error('Error reloading order:', error);
        }
    };

    const deleteTicketById = async (ticketIdOrIds) => {
        try {
            if (!regularToken) {
                throw new Error("No regularToken token found at deleteTicketById");
            }

            if (currentOrder != null && currentOrder.id) {
                // Handle both single ID and array of IDs
                const ticketIdsToRemove = Array.isArray(ticketIdOrIds) ? ticketIdOrIds : [ticketIdOrIds];
                await deleteTicketsFromBasket(baseUrl, "token", regularToken, currentOrder.id, ticketIdsToRemove);

                // Reload the order to get updated tickets
                await reloadOrder();

                // Check if there are no tickets left and navigate to tickets page
                const updatedOrder = await GetShopBasketOrder(baseUrl, "token", regularToken, currentOrder.id);
                if (!updatedOrder.tickets || updatedOrder.tickets.length === 0) {
                    if (bookingType) {
                        navigate(`/${language}/tickets/${bookingType}`);
                    } else {
                        navigate(`/${language}/tickets-rally`);
                    }
                }
            }
        } catch (error) {
            console.error('Error deleting ticket by id:', error);
        }
    };

    const handleNextButton = async (e) => {
        if (username && username.length > 0) {
            // skip login and registration page for already logged in user
            navigate(`/${language}/information`);
        } else {
            // Navigate to the next page on success
            navigate(`/${language}/username`);
        }
    };

    return (
        <>
            <Header language={language} pagePath="summary" pageTitle={resources?.SummaryTitle}
                ticketCount={currentOrder?.tickets?.length || 0} />

            <div className="page-container">

                <div className="container wrapper">

                    <div className="row">
                        <div className="col-md-12">
                            <OrderSummary
                                tickets={tickets}
                                order={currentOrder || {}}
                                resources={{
                                    Ticket: resources?.Ticket,
                                    TicketPrice: resources?.TicketPrice,
                                    _Total: resources?._Total,
                                    _TotalInclTaxes: resources?._TotalInclTaxes
                                }}
                                language={language}
                                showDeliveryCosts={false}
                                showPromotionCodes={false}
                                onDeleteTicket={deleteTicketById}
                            />
                        </div>
                    </div>

                    {/* button */}
                    <div className="row mt-5">
                        <div className="col-6">
                            <button
                                className="btn-custom white"
                                type="submit"
                                onClick={() => navigate(-1)}
                            >
                                {resources?._Back}
                            </button>
                        </div>

                        <div className="col-6 text-end">
                            <button
                                className="btn-custom"
                                type="submit"
                                onClick={handleNextButton}
                            >
                                {resources?._Next}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer language={language} />
        </>
    )
}

export default Information;